import { render } from "./ModelCarrusel.vue?vue&type=template&id=936b6094&scoped=true"
import script from "./ModelCarrusel.vue?vue&type=script&lang=js"
export * from "./ModelCarrusel.vue?vue&type=script&lang=js"

import "./ModelCarrusel.vue?vue&type=style&index=0&id=936b6094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936b6094"]])

export default __exports__